import useAppQuery, { AppQueryOptions } from 'hooks/use-app-query'
import { getNotificationsCount } from 'services/notification'
import { NotificationsCountResponse } from 'services/types/notification'
import { STALE_TIME } from 'utils/constants'
import { notificationsCountKey } from 'utils/constants/queryKey'

export const useGetNotificationsCount = (options?: AppQueryOptions<NotificationsCountResponse>) =>
  useAppQuery(notificationsCountKey.list(), () => getNotificationsCount(), {
    ...options,
    staleTime: STALE_TIME.hour / 2,
  })
